__turbopack_context__.v({
  "root": "CarouselProvider-module-scss-module__J121KG__root",
});
